<template>
    <header class="header-nav">
        <div class="section-header">
            <slot></slot>
        </div>
    </header>
</template>

<script>

export default {
    name: "TheNav",
}
</script>
